var eId;
login_state.e_id ? eId = login_state.e_id : eId = sessionStorage.getItem('murmur');
var other_openid;
var host_name
if (location.hostname == 'www.heyreal.ai') {
  host_name = "https://www.heyreal.ai";
} else if (location.hostname == 'www.sandbox.heyreal.ai') {
  host_name = "https://sandbox.heyreal.ai";
} else {
  host_name = `http://${location.hostname}`;

}
const staTus = {
  num_like: $('.like_num').html(),
  num_common: $('.collection_num').html(),
  share_num: $('.share_num').html()
};
let userInfo;
let isValid = true;
const commentTxtEle = document.getElementById('comment-txt');


commentTxtEle.addEventListener('input', function () {
  clearErrors('commentTxtError');
  var commentDetails = this.value.trim();
  if (commentDetails.length > 200) {
    showError('commentTxtError', i18n[lang].chat_story_characters);
  }
})
$(document).on('click','.more', function (e) {
  e = e || window.event, window.event ? e.stopPropagation() : window.cancelBubble = !0;
  checkLoginStatus(); // 每次点击按钮时先检查登录状态
  if (window.isLoggedIn) {
    console.log(1111);
    $(this).parent().siblings('.function_lists').toggleClass('active');
    $(this).toggleClass('active');
  }
});
$('.select_zoon .top_item').on('click', function () {
  $(this).parent().toggleClass('active');
});
$('.select_zoon .select_item').on('click', function () {
  $(this).parent().parent().removeClass('active');
  $(this).parent().siblings('.top_item').find('span').html($(this).html());
});
var getRobotInfo = {
  "roleid": 1
};
var iSsameUser = false;
$(document).on('click', function (e) {
  e = e || window.event, window.event ? e.stopPropagation() : window.cancelBubble = !0;
  $('.more,.function_lists').removeClass('active');
  $('.rating_mask').removeClass('active');
});
//返回上一页面
$('.character_top_icon .character_back').on('click', function () {
  if (window.history) {
    window.history.go(-1);
  } else {
    window.location.href = host;
  }
});
function _lacal() {
  return window.location.href.split('/character/')[1];
};
//拼接分享链接
var link_before = $('#share_link').html();
// var link_before = '445761';
$('#share_link').html(host + 'character/' + link_before);
var _uid = null;
if (typeof $('.character_user_id').html() == 'number' || typeof Number($('.character_user_id').html()) == 'number') {
  _uid = $('.character_user_id').html();
} else {
  $('.violationReminder').addClass('active');
};
//复制
function copyToClipboard(text) {
  var textarea = document.createElement('textarea');
  textarea.style.position = 'fixed';
  textarea.style.opacity = 0;
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
};
$('.copy_btn').on('click', function () {
  copyToClipboard($('#share_link').html());
  if (!this.classList.contains('active')) {
    getAjax('/api/addShare', {
      "roleid": link_before,
      "be_share_id": _uid,
    }).then(res => {
      if (res.code == 200) {

      }
    });
    staTus.share_num++
    $('.share_num').html(staTus.share_num);
    $('.character .share').addClass('active');
    $('.character .share span').animate({ opacity: 1, top: '-1.125rem' }).delay(3000).animate({ opacity: 0, top: '-1rem' }, 10);
  }
  $(this).addClass('active');
  $(this).parent().siblings('.share_error').addClass('active');

});
//分享
$('.profile_share').on('click', function () {
  $('.share_box').addClass('active');
  $('.profile_mask').addClass('active');
  $('body').addClass('hide_pro');


});
$('.profile_close').on('click', function () {
  $(this).parent().removeClass('active');
  $('.profile_mask').removeClass('active');
  $('body').removeClass('hide_pro');
});
let token = JSON.parse(cookie.getcookie('user')) ? JSON.parse(cookie.getcookie('user')).token : null;
//退出登陆后页面跳转的逻辑
function checkLoginAndRedirect(url) {
  if (!token) {
    $('.main_section').append(`<div class="loginRequiredMask">
          <div class="loginRequired">
              <img src="/images/index/logo_pad.svg" class="logo" alt="Logo Pad"/>
              <div class="title">${i18n[lang].public_Login_Required}</div>
              <div class="desc">${i18n[lang].public_In_order}</div>
              <div class="button">${i18n[lang].log_in}</div>
          </div>
      </div>`)
    manage('Popup_Login_View');
  } else {
    location.href = url;
  }
  $('.loginRequiredMask').on('click', function () {
    $('.main_section .loginRequiredMask').remove();
  })
  $('.loginRequired').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
  })
  $('.loginRequiredMask .button').on('click', function (e) {
    manage('Popup_Login_Click');
    location.href = `${lang_path}/account/login/`
  })
};
function _status(a, b) {
  if (a) {
    $('.errorPop span').html(b);
    $('.errorPop.success').addClass('active');
  } else {
    $('.errorPop span').html(b);
    $('.errorPop.error').addClass('active');
  }
}
function _notlogin() {
  checkLoginStatus(); // 每次点击按钮时先检查登录状态
  if (!window.isLoggedIn) {
    $('.main_section').append(`<div class="loginRequiredMask">
          <div class="loginRequired">
              <img src="/images/index/logo_pad.svg" class="logo" alt="Logo Pad"/>
              <div class="title">${i18n[lang].public_Login_Required}</div>
              <div class="desc">${i18n[lang].public_In_order}</div>
              <div class="button">${i18n[lang].log_in}</div>
          </div>
      </div>`)
    manage('Popup_Login_View');
    $('.loginRequiredMask').on('click', function () {
      $('.main_section .loginRequiredMask').remove();
    })
    $('.loginRequired').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
    })
    $('.loginRequiredMask .button').on('click', function (e) {
      manage('Popup_Login_Click');
      location.href = `${lang_path}/account/login/`
    })
    return;
  } else {
    error(i18n[lang].public_Some_errors)
  }
};
//收藏
$(document).ready(function () {
  checkLoginStatus();
  //数据存cookie
  var character_roleid = $('.character_roleid').html();
  cookie.setcookie('character_roleid', character_roleid, 90);
  //判断是不是自己创建的角色
  setTimeout(function () {
    var uid = cookie.getcookie('userInfoData') ? JSON.parse(cookie.getcookie('userInfoData')).uid : null;
    if (!_uid) {
      _uid = uid
    };
    if ($('.character_user_id').html() != uid) {
      // $('.character .character_edit').hide();
    } else if ($('.character_user_id').html() == uid) {
      $('#person_creator').attr('href', `${lang_path}/account/profile/`);
    };
    var lisTening_login = null;
    clearInterval(lisTening_login);
    lisTening_login = setInterval(function () {
      var uid1 = cookie.getcookie('userInfoData') ? JSON.parse(cookie.getcookie('userInfoData')).uid : null;
      if (window.isLoggedIn && $('.character_user_id').html() == uid1) {
        // $('.character .character_edit').show();
        clearInterval(lisTening_login);
        return;
      } else if (!window.isLoggedIn) {
        $('.character .collection').removeClass('allowed');
        $('.character .btn_like').removeClass('allowed');
        // $('.character .character_edit').hide();
        clearInterval(lisTening_login);
        $('.follow_btn').html(i18n[lang].public_Follow).removeClass('allowed').addClass('fit');
      }
    }, 1000)
  }, 3000);
  //获取按钮状态
  getAjax(_url.getMoreLists, {
    "roleid": link_before
  }).then(res => {
    if (res.code == 200) {
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].title == 'Start Chat') {
          if (res.data[i].status == 1) {
            $('.rightNavigation .function_lists').append(`<a href="/chat/${link_before}" class="character_chat">${i18n[lang].character_Start_Chat}</a>`)
          } else {

          }
        } else if (res.data[i].title == 'Edit') {
          if (res.data[i].status == 1) {
            $('.rightNavigation .function_lists').append(`<a href="${lang_path}/character/edit/${link_before}" class="character_edit"">${i18n[lang].character_Edit}</a>`)
          } else {

          }
        } else if (res.data[i].title == 'Report') {
          if (res.data[i].status == 1) {
            $('.rightNavigation .function_lists').append(`<span class="report">${i18n[lang].public_Report}</span>`)
          } else {

          }
        }

      };
    } else if (res.code == 204) {
      $('.character .collection').removeClass('allowed')
      $('.character .btn_like').removeClass('allowed')
    }
  });
  //获取收藏状态
  getAjax(_url.getCollect, {
    "roleid": link_before
  }).then(res => {
    if (res.code == 200) {
      if (res.data.collect_status == 0) {
        $('.character .collection').removeClass('active').addClass('allowed');
      } else {
        $('.character .collection').addClass('active').addClass('allowed');
      };
      if (res.data.likes_status == 0) {
        $('.character .btn_like').removeClass('active').addClass('allowed');
      } else {
        $('.character .btn_like').addClass('active').addClass('allowed');
      }
    } else if (res.code == 204) {
      $('.character .collection').removeClass('allowed')
      $('.character .btn_like').removeClass('allowed')
    }
  });
  getAjax(_url.getRobotInfo, {
    "roleid": link_before
  }).then(res => {
    var uid1 = cookie.getcookie('userInfoData') ? JSON.parse(cookie.getcookie('userInfoData')).uid : null;
    if (res.code == 200) {
      if (!res.data) {
        return;
      }
      other_openid = res.data.userProfile.openid;
      if (res.data.uid == res.data.userProfile.uid) {
        iSsameUser = true;
      };
      var robotInfo = res.data;
      var wordsBanType = null;
      if(!robotInfo.vague_status){
        $('.person_img_box img').addClass('blur-status');
      }
      if (res.data.share_num != Number($('.share_num').html())) {
        $('.share_num').html(res.data.share_num);
      };
      if (res.data.like_num != Number($('.like_num').html())) {
        $('.like_num').html(res.data.like_num);
      };
      if (res.data.collection_num != Number($('.collection_num').html())) {
        $('.collection_num').html(res.data.collection_num);
      };
      if(res.data.avatar_url){
        var avatar_url = res.data.avatar_url;
        if(avatar_url.indexOf('250x250/')>-1){
          // avatar_url = avatar_url.replace('250x250/','');
        }
        var img = new Image();
        img.src = res.data.avatar_url;
        img.onload = function () {
        };
        $('#person_img').attr('src',avatar_url);
        $('#person_img').on('error',function (e) {
          $(this).attr('src','/images/index/defaultAvatar.svg');
        });
      }
      var like_num = 0;
      if (res.data.like_num && res.data.like_num < 1000) {
        like_num = res.data.like_num;
      } else if (res.data.like_num && res.data.like_num >= 1000 && res.data.like_num < 1000000) {
        like_num = (res.data.like_num / 1000).toFixed(1) + 'K';
      } else if (res.data.like_num && res.data.like_num >= 1000000 && res.data.like_num < 1000000000) {
        like_num = (res.data.like_num / 1000000).toFixed(1) + 'M';
      } else if (res.data.like_num && res.data.like_num >= 1000000000) {
        like_num = (res.data.like_num / 1000000).toFixed(1) + 'B';
      };
      $('.like_num').html(like_num);
      var collection_num = 0;
      if (res.data.collection_num && res.data.collection_num < 1000) {
        collection_num = res.data.collection_num;
      } else if (res.data.collection_num && res.data.collection_num >= 1000 && res.data.collection_num < 1000000) {
        collection_num = (res.data.collection_num / 1000).toFixed(1) + 'K';
      } else if (res.data.collection_num && res.data.collection_num >= 1000000 && res.data.collection_num < 1000000000) {
        collection_num = (res.data.collection_num / 1000000).toFixed(1) + 'M';
      } else if (res.data.collection_num && res.data.collection_num >= 1000000000) {
        collection_num = (res.data.collection_num / 1000000).toFixed(1) + 'B';
      };
      $('.collection_num').html(collection_num);
      var share_num = 0;
      if (res.data.share_num && res.data.share_num < 1000) {
        share_num = res.data.share_num;
      } else if (res.data.share_num && res.data.share_num >= 1000 && res.data.share_num < 1000000) {
        share_num = (res.data.share_num / 1000).toFixed(1) + 'K';
      } else if (res.data.share_num && res.data.share_num >= 1000000 && res.data.share_num < 1000000000) {
        share_num = (res.data.share_num / 1000000).toFixed(1) + 'M';
      } else if (res.data.share_num && res.data.share_num >= 1000000000) {
        share_num = (res.data.share_num / 1000000).toFixed(1) + 'B';
      };
      $('.share_num').html(share_num);
      res.data.Characters?$('#Characters').html(res.data.Characters):$('#Characters').html('0');
      res.data.fraction?$('#fraction').html(res.data.fraction):$('#fraction').html('0');
      var chats_num = 0;
      if (res.data.chats_num && res.data.chats_num < 1000) {
        chats_num = res.data.chats_num;
      } else if (res.data.chats_num && res.data.chats_num >= 1000 && res.data.chats_num < 1000000) {
        chats_num = (res.data.chats_num / 1000).toFixed(1) + 'K';
      } else if (res.data.chats_num && res.data.chats_num >= 1000000 && res.data.chats_num < 1000000000) {
        chats_num = (res.data.chats_num / 1000000).toFixed(1) + 'M';
      } else if (res.data.chats_num && res.data.chats_num >= 1000000000) {
        chats_num = (res.data.chats_num / 1000000).toFixed(1) + 'B';
      };
      $('.hot-num').html(chats_num);
      res.data.DateCreated?$('#DateCreated').html(res.data.DateCreated):null;
      res.data.LastUpdated?$('#LastUpdated').html(res.data.LastUpdated):null;
      robotInfo.wordsBanType ? wordsBanType = robotInfo.wordsBanType.map(item => item.name).join(', ') : wordsBanType = null;
      if (robotInfo.robot_type === 0) {
        if (robotInfo.check_status === 0) {
          // if($('.character_user_id').html()==uid){
          if (robotInfo.audit_img === 0 && robotInfo.audit_words === 0) {
            _status(false, `${i18n[lang].character_info_1} ${wordsBanType} ${i18n[lang].character_info_1}`)
          } else if (robotInfo.audit_words === 0) {
            _status(false, `${i18n[lang].character_info_1} ${wordsBanType} ${i18n[lang].character_info_3}`)
          } else if (robotInfo.audit_img === 0) {
            _status(false, i18n[lang].character_restore)
          }else if (robotInfo.audit_img  === 2) {
            // _status(false, i18n[lang].character_info_4)
            $('.errorPop span').html(i18n[lang].character_info_4);
            $('.errorPop.warning').addClass('active');
        }
        }
      }
      $('#percent').css('width', ($('#fraction').html() / 5) * $('.rating_zoon .rang').width());
      var creatorUid = cookie.getcookie('userInfoData') ? JSON.parse(cookie.getcookie('userInfoData')).uid : null;
      $('.creator_section').remove();
      $('.left_info .left_title,.right_profile .left_title').after(`<div class="creator_section itemDiv">
      <div class="creator_top flex_box">
        <a href="${lang_path}/account/profile/${res.data.userProfile.openid}" target="_blank" class="character_link"><img class="creator_img" src="${res.data.userProfile.avatar_url}" alt="Character Avatar" width="328" height="328" onerror="this.onerror=null;this.src='/images/index/defaultAvatar.svg';" /></a>
        <div class="middle_part">
          <p class="creator_name">${res.data.userProfile.nickname}</p>
          <div class="interactive_zoon flex_box">
            <p><i class="icon_chat"></i>
            <span class="num_chat">${autoNumberTransform(res.data.userProfile.interaction)}</span></p>
            <p><i class="icon_follow"></i>
            <span class="num_follow">${autoNumberTransform(res.data.userProfile.fans_num)}</span></p>
          </div>
        </div>
        <a href="${lang_path}/account/profile/${res.data.userProfile.openid}" target="_blank" class="jump">${i18n[lang].character_View_Profile}</a>
      </div>
      <p class="info" id="creator_Introduction">${res.data.userProfile.introduction?res.data.userProfile.introduction:i18n[lang].character_not_info}</p>
      ${creatorUid && creatorUid == res.data.uid?'':'<span class="follow_btn allowed" attr-openid="'+res.data.userProfile.openid+'"><img src="/images/account/loading.svg" alt="Loading"></span>'}
      <ul class="character_list"></ul>
      <a href="${lang_path}/account/profile/${res.data.userProfile.openid}" target="_blank" class="view_all">${i18n[lang].character_View_all} &GT;&GT;</a>
      </div>`);
      getAjax(_url.getFollowStatus, {
        "uid": res.data.userProfile.openid,
      }).then(res => {
          if (res.code == 200) {
              if (res.data.follow_status == 0) {
                  $('.follow_btn').removeClass('fit').addClass('active').removeClass('followed').addClass('allowed');
                  $('.follow_btn').html(i18n[lang].public_Follow)
              } else {
                  $('.follow_btn').removeClass('fit').removeClass('active').addClass('followed').addClass('allowed');
                  $('.follow_btn').html(i18n[lang].public_Following)
              }
          } else if (res.code == 204) {
              $('.follow_btn').html(i18n[lang].public_Follow).removeClass('allowed');
          } else {
          }
      });
      var otherUid = res.data.uid;
      getAjax(_url.popularList, {
        "roleid": link_before,
        "nsfw": cookie.getcookie('sw')?cookie.getcookie('sw'):1,
        "uid":res.data.uid
      }).then(res => {
        if (res.code == 200) {
          if (!res.data) {
            return;
          }
          res.data.forEach(function(data, index) {
            $('.character_list').append(`
            <li>
              <a href="${lang_path}/character/${data.roleid}" target="_blank" class="character_li character_li${data.roleid}">
                <div class="character_up flex_box">
                  <img class="character_img" src="${data.avatar_url}" alt="Character Avatar" width="328" height="328" onerror="this.onerror=null;this.src='/images/index/defaultAvatar.svg';" />
                  <div class="middle_part">
                    <p class="character_name">${data.name}</p>
                    <div class="interactive_zoon flex_box">
                      <p><i class="icon_chat"></i>
                      <span class="num_chat">${autoNumberTransform(data.chats_num)}</span></p>
                      <p><i class="icon_like ${data.is_like==1?'active':''}"></i>
                      <span class="num_like">${autoNumberTransform(data.like_num)}</span></p>
                    </div>
                    <p class="character_info">${data.describe?data.describe:i18n[lang].character_not_info}</p>
                  </div>
                </div>
                <span class="to_chat to_chat${data.roleid}" attr-href="/chat/${data.roleid}">${i18n[lang].character_Chat_Now}</span>
              </a>
            </li>
            `);
            $(`.to_chat${data.roleid}`).on('click', function(e){
              e.stopPropagation();
              e.preventDefault();
              // 每次点击按钮时先检查登录状态
              if (!window.isLoggedIn) {
                login_status();
              } else {
                window.open($(this).attr('attr-href'), '_blank');
              }
            });
            $(`.character_li${data.roleid} .icon_like`).on('click', function(e){
              e.stopPropagation();
              e.preventDefault();
              checkLoginStatus(); 
              // 每次点击按钮时先检查登录状态
              if (!window.isLoggedIn) {
                login_status();
              } else {
                if($(this).attr('class').indexOf('active')>-1){
                  create_like(data.roleid, otherUid, 0, $(this), _creatFlags)
                }else{
                  create_like(data.roleid, otherUid, 1, $(this), _creatFlags)
                }
              }
            });
          })
        } else if (res.code == 204) {
          $('.character .collection').removeClass('allowed')
          $('.character .btn_like').removeClass('allowed')
        } else if (res.code == 2304) {
          $('.violationReminder').addClass('active').find('p').html(i18n[lang].album_private)
        } else if (res.code == 2305) {
          $('.violationReminder').addClass('active').find('p').html(i18n[lang].character_restricted)
        }
      });

    } else if (res.code == 204) {
      $('.character .collection').removeClass('allowed')
      $('.character .btn_like').removeClass('allowed')
    } else if (res.code == 2304) {
      $('.violationReminder').addClass('active').find('p').html(i18n[lang].album_private)
    } else if (res.code == 2305) {
      $('.violationReminder').addClass('active').find('p').html(i18n[lang].character_restricted)
    }
  });
  var story_list_page = {
    characters: 1,
    characters_total: 0,
    characters_num: 0,
    favorites: 1,
    favorites_total: 0,
    favorites_num: 0,
    likes: 1,
    likes_total: 0,
    likes_num: 0,
  };
  var shawdow_mask = false;
  var _first = true;
  var robot_type = null, my_card_index = 0;
  var storyType = 2, storyOrder = 2;
  let isRequestInProgressStory = false;
  var _first_check = true;
  var story_index = 0;
  var isLoading = true;
  async function add_type_lists(storyType, storyOrder) {
    if (isRequestInProgressStory) {
        return;
    };
    if (_first_check) {
        isRequestInProgressStory = true;
        story_list_page.characters = 1;
        per_page = story_list_page.characters;
        story_list_page.characters_num = 0;
        //第一个盒子渲染
        getAjax(_url.detailStoryList, {
            "roleid": link_before,
            "type": storyType,
            "order": storyOrder,
            "page": 1,
        }).then(res => {
            if (res.code == 200) {
                $('.main_right .story_section').empty();
                story_list_page.characters_total = res.last_page;
                if (res.data.length >= 1) {
                    res.data.forEach(response => {
                        var _openid = '', _nickname = '';
                        if (response.userProfile && response.userProfile.openid) {
                            _openid = response.userProfile.openid
                        }
                        if (response.userProfile && response.userProfile.nickname) {
                            _nickname = response.userProfile.nickname
                        };
                        story_list_page.characters_num++;
                        var _like_num, _chats_num;
                        response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                        response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                        $('.main_right .story_section').append(`
                         <div class="ivu-col ivu-col-span-xs-12 ivu-col-span-sm-12 ivu-col-span-md-8 ivu-col-span-lg-6 ivu-col-span-xl-4 ivu-col-span-xxl-4 itemDiv">
                            <a href="${lang_path}/character/${response.roleid}/story/${response.id}" target="_blank" target="_blank" id="robot${response.roleid}_1" class="item homeItemInPHP robot${response.roleid}" data-roleid="${response.roleid}">
                              <p class="story_name">${response.title}</p>
                              <p class="story_author">${i18n[lang].chat_story_Author} <span class="author_name story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type} attr-id="${response.users.openid}">${response.nickname}</span></p>
                              <div class="story_info">
                                <p class="info">${response.beginning_content}</p>
                              </div>
                              <div class="status_info flex_box">
                                  <div class="status_item">
                                  <p class="status_title">${i18n[lang].public_Views}</p>
                                  <p class="status_info">${autoNumberTransform(response.views)}</p>
                                  </div>
                                  <div class="status_item">
                                  <p class="status_title">${i18n[lang].public_Likes}</p>
                                  <p class="status_info">${autoNumberTransform(response.likes)}</p>
                                  </div>
                                  <div class="status_item">
                                  <p class="status_title">${i18n[lang].public_Comment}</p>
                                  <p class="status_info">${autoNumberTransform(response.comments_num)}</p>
                                  </div>
                              </div>
                            </a>
                          </div>`);
                        $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            if ($(this).data('anonymoustype') == 1) {
                                error(i18n[lang].public_story_anonymous)
                            } else {
                              window.open(`${lang_path}/account/profile/${response.users.openid}`,'_blank');
                            }
                        });


                    });
                } else {
                    const emptyElement = $(`
                      <p class="info">${i18n[lang].character_Share_Story}</p>
                      <a href="/chat/${link_before}" class="chat">${i18n[lang].character_Start_Chat}</a>
                    `);
                    if (!$('.story_section').find('.show_result').length) {
                      $('.story_section').append(emptyElement);
                      $('.story_section').addClass('align');
                      unbindScroll();
                    }
                };
                setTimeout(() => {
                    story_list_page.characters++;
                    if (res.data.length > 1 && story_list_page.characters > story_list_page.characters_total) {
                      unbindScroll();
                      isLoading = true;
                    } else{
                      isLoading = false;
                    }
                    $('.story_section #loadBox').hide();
                    // bindScroll();
                }, 1500)
            };
            isRequestInProgressStory = false;
        }).catch(error => {
            console.error('Error fetching robot list:', error);
            isRequestInProgressStory = false; // 确保在请求失败时重置标志变量
        })
        _first_check = false;
    };
  };
  add_type_lists(storyType, 2);
  function loadMore (){
    // if(isRequestInProgressStory == true)return false; 
    if(isLoading){return false;}
    else{
      isLoading = true;
      addChatStorySectionLoading();
      getAjax(_url.detailStoryList, {
        "roleid": link_before,
        "type": storyType,
        "order": storyOrder,
        "page": story_list_page.characters,
      }).then(res => {
          if (res.code == 200) {
              // $('.main_right .story_section').empty();
              $('.story_section .ivu-col-span-xxl-4.tempItemDiv').remove();
              story_list_page.characters_total = res.last_page;
              if (res.data.length >= 1) {
                  res.data.forEach(response => {
                      var _openid = '', _nickname = '';
                      if (response.userProfile && response.userProfile.openid) {
                          _openid = response.userProfile.openid
                      }
                      if (response.userProfile && response.userProfile.nickname) {
                          _nickname = response.userProfile.nickname
                      };
                      story_list_page.characters_num++;
                      var _like_num, _chats_num;
                      response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                      response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                      $('.main_right .story_section').append(`
                       <div class="ivu-col ivu-col-span-xs-12 ivu-col-span-sm-12 ivu-col-span-md-8 ivu-col-span-lg-6 ivu-col-span-xl-4 ivu-col-span-xxl-4 itemDiv">
                          <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot${response.roleid}_1" class="item homeItemInPHP robot${response.roleid}" data-roleid="${response.roleid}">
                            <p class="story_name">${response.title}</p>
                            <p class="story_author">${i18n[lang].chat_story_Author} <span class="author_name story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type} attr-id="${response.users.openid}">${response.nickname}</span></p>
                            <div class="story_info">
                              <p class="info">${response.beginning_content}</p>
                            </div>
                            <div class="status_info flex_box">
                                <div class="status_item">
                                <p class="status_title">${i18n[lang].public_Views}</p>
                                <p class="status_info">${autoNumberTransform(response.views)}</p>
                                </div>
                                <div class="status_item">
                                <p class="status_title">${i18n[lang].public_Likes}</p>
                                <p class="status_info">${autoNumberTransform(response.likes)}</p>
                                </div>
                                <div class="status_item">
                                <p class="status_title">${i18n[lang].public_Comment}</p>
                                <p class="status_info">${autoNumberTransform(response.comments_num)}</p>
                                </div>
                            </div>
                          </a>
                        </div>`);
                      $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                          e.preventDefault();
                          e.stopPropagation();
                          if ($(this).data('anonymoustype') == 1) {
                              error(i18n[lang].public_story_anonymous)
                          } else {
                            window.open(`${lang_path}/account/profile/${response.users.openid}`, '_blank');
                          }
                      });
  
  
                  });
              }
              setTimeout(() => {
                  story_list_page.characters++;
                  if (story_list_page.characters > story_list_page.characters_total) {
                    isLoading = true;
                    unbindScroll();
                  } else{
                    isLoading = false;
                  }
                  $('.story_section #loadBox').hide();
                  // bindScroll();
              }, 1500)
          };
          isRequestInProgressStory = false;
      }).catch(error => {
          console.error('Error fetching robot list:', error);
          isRequestInProgressStory = false; // 确保在请求失败时重置标志变量
      })
    }
  };
  // 解除绑定 scroll 事件
  function unbindScroll() {
    $('.main_right .ivu-row').off('scroll', handleScroll);
  }

  // 重新绑定 scroll 事件
  function bindScroll() {
    if(story_index==0){
      $('.main_right .ivu-row').on('scroll', handleScroll);
    } 
  }

  // 定义 scroll 事件处理函数
  function handleScroll() {
      const scrollTop = $(this).scrollTop();
      const scrollHeight = $('#main_right').height();
      const clientHeight = $(this).height();
      if (scrollTop + clientHeight >= scrollHeight - 200) {
          loadMore();
      }
  }
  bindScroll();
  //关注
  $(document).on('click','.main_right .follow_btn', function () {
    if ($(this).attr('class').indexOf('allowed') > -1 && $(this).attr('class').indexOf('active') == -1 && $(this).attr('class').indexOf('fit') == -1) {
        $(this).removeClass('allowed');
        $(this).html('<img src="/images/account/loading.svg" alt="Loading">');
        getAjax(`/api/followUpdate`, {
            "uid": $(this).attr('attr-openid'),
            "status": 0
        }).then(res => {
            $(this).addClass('allowed');
            if (res.code == 200) {
                success(i18n[lang].public_Successfully_Unfollow)
                $(this).html(i18n[lang].public_Follow)
                $(this).addClass('active').removeClass('followed');
                setOtherUserInfo();
            } else {
                error('Failed to Unfollow')
                $(this).html(i18n[lang].public_Following)
            }
        });
    } else if ($(this).attr('class').indexOf('allowed') > -1 && $(this).attr('class').indexOf('active') > -1 && $(this).attr('class').indexOf('fit') == -1) {
        $(this).removeClass('allowed');
        $(this).html('<img src="/images/account/loading.svg" alt="Loading">')
        getAjax(`/api/followUpdate`, {
            "uid": $(this).attr('attr-openid'),
            "status": 1
        }).then(res => {
            $(this).addClass('allowed');
            if (res.code == 200) {
                success('Successfully  Followed')
                $(this).html(i18n[lang].public_Following)
                $(this).removeClass('active').addClass('followed');
                setOtherUserInfo();
            } else {
                error(i18n[lang].public_Failed_Followed)
                $(this).html(i18n[lang].public_Follow)
            }
        });
    } else if ($(this).attr('class').indexOf('allowed') == -1 && $(this).attr('class').indexOf('fit') >= -1) {
      _notlogin();
    }
  });
  var _creatFlags = false;
    function create_like(roleid, uid, status, element, _creatFlags) {
        var starTime = new Date().getTime();
        if (!_creatFlags) {
            _creatFlags = true;
            getAjax(_url.likesUpdate, {
                "roleid": roleid,
                "be_liked_id": uid,
                "status": status
            }).then(res => {
                const responseDate = new Date().getTime();
                if (responseDate - starTime >= 5000) {
                    _creatFlags = false;
                } else {
                    setTimeout(function () {
                        _creatFlags = false;
                    }, 5000 - (responseDate - starTime));
                };
                if (res.code == 200) {
                  var _num = Number(element.siblings('.num_like').text());
                    if (status) {
                      element.addClass('active');
                      element.siblings('.num_like').text(_num+1);
                      success(i18n[lang].public_Successfully_Like)
                    } else {
                      element.removeClass('active');
                      element.siblings('.num_like').text(_num-1);
                      success(i18n[lang].public_Successfully_Unlike);
                    }
                } else {
                    if (status) {
                        error(i18n[lang].public_Failed_Like)
                    } else {
                        error(i18n[lang].public_Failed_Unlike);
                    }
                }
            }).catch(res => {
                if (status) {
                    error(i18n[lang].public_Failed_Like)
                } else {
                    error(i18n[lang].public_Failed_Unlike);
                }
            });
        } else if (_creatFlags) {
            error(i18n[lang].public_too_fast);
        }
    };
  getAjax(_url.threePhotos, {
    "roleid": link_before
  }).then(res => {
    if (res.code == 200) {
      $('.tab_section').before(`<div class="photo_section">
        <h2 class="title_h_profile">${i18n[lang].character_Photo_Album}</h2>
        <div class="photo_list flex_box" id="photo_list">
          <div class="img_list">
            <img data-original="" src="/images/index/defaultAvatar.svg" alt="Character" width="168" height="168" />
          </div>
          <div class="img_list ">
            <img data-original="" src="/images/index/defaultAvatar.svg" alt="Character" width="168" height="168" />
          </div>
          <div class="img_list">
            <img data-original="" src="/images/index/defaultAvatar.svg" alt="Character" width="168" height="168" />
          </div>
          <div class="img_list">
            <img data-original="" src="/images/index/defaultAvatar.svg" alt="Character" width="168" height="168" />
          </div>
        </div>
        <a href="" class="view_all">${i18n[lang].character_View_all}(<span id="view_num"></span>) &gt;&gt;</a>
      </div>`);
      checkLoginStatus();
      $.each(res.data,function(ind,itm){
        $('.img_list').eq(ind).find('img').attr('src',itm.image);
        if(itm.status==0||itm.status==2){
          $('.img_list').eq(ind).addClass('active');
          $('.img_list').eq(ind).find('img').attr('data-original','');
          if (!window.isLoggedIn) {
            $('.img_list').eq(ind).append(`<span class="album_img_mask"></span>`);
          }else{
            $('.img_list').eq(ind).append(`<a href="${lang_path}/character/album/${link_before}"></a>`);
          }
        }else{
          $('.img_list').eq(ind).removeClass('active');
          $('.img_list').eq(ind).find('img').attr('data-original',itm.image);
        }
      });
      $('#view_num').html(res.count);
      $('.view_all').attr('href',`${lang_path}/character/album/`+link_before);
       // 每次点击按钮时先检查登录状态
      if (!window.isLoggedIn) {
        $('.album_img_mask').on('click', function(){
          $('.main_section').append(`<div class="loginRequiredMask">
            <div class="loginRequired">
              <img src="/images/index/logo_pad.svg" class="logo" alt="Logo Pad"/>
              <div class="title">${i18n[lang].public_Login_Required}</div>
              <div class="desc">${i18n[lang].public_In_order}</div>
              <div class="button">${i18n[lang].log_in}</div>
            </div>
          </div>`);
        });
        $(document).on('click', '.loginRequiredMask', function () {
          $('.main_section .loginRequiredMask').remove();
        });
        $(document).on('click', '.loginRequired', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
        $(document).on('click','.loginRequiredMask .button', function (e) {
            manage('Popup_Login_Click');
            location.href = `${lang_path}/account/login/`
        });
      } else {
        var photo_list = document.getElementById('photo_list');
        var viewer = new Viewer(photo_list, {
          url: 'data-original',
          toolbar: {
  
            prev: function() {
              viewer.prev(true);
            },
  
            play: true,
  
            next: function() {
              viewer.next(true);
            },
            zoomIn: 4,
            zoomOut: 4,
            oneToOne: 4,
            reset: 4,
            prev: 4,
            play: {
              show: 20,
              size: 'large',
            },
            download: function() {
              const a = document.createElement('a');
              a.href = viewer.image['data-original'];
              a.download = viewer.image.alt;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            },
          },
        });
      };
    } else if (res.code == 9001) {
      error(i18n[lang].public_Network_error);
    } else if (res.code == 2105) {
      return false;
    } else if (res.code == 204) {
      return false;
    } else {
      error(i18n[lang].public_Network_error);
    }
    if(window.location.href.indexOf('?#') !== -1){
      $('.tab_section .tab_item').eq(1).trigger('click');
      if($(window).width()<769){
        setTimeout(function() {
          $('.ivu-row-center').scrollTop($(window.location.href.split('?')[1]).offset().top-$(window.location.href.split('?')[1]).height());
        },1000);
      }else{
        $('.ivu-row').scrollTop($(window.location.href.split('?')[1]).offset().top-$(window.location.href.split('?')[1]).height());
      }
      $(window.location.href.split('?')[1]).addClass('shine');
    };
  });
  //收藏 取消收藏
  $('.character .collection').on('click', function () {
    checkLoginStatus();
    if (window.isLoggedIn) {
      if ($(this).attr('class').indexOf('allowed') > -1 && $(this).attr('class').indexOf('active') > -1 && $(this).attr('class').indexOf('fit') == -1) {
        $(this).addClass('fit');
        $(this).removeClass('allowed');
        $(this).removeClass('active');
        staTus.num_common--
        $('.collection_num').html(staTus.num_common);
        getAjax(_url.collectUpdate, {
          "roleid": link_before,
          "be_collected_id": _uid,
          "status": 0
        }).then(res => {
          $(this).removeClass('fit');
          if (res.code == 200) {
            $(this).addClass('allowed');
            success(i18n[lang].character_Successfully_Remove)
            $(this).removeClass('active').removeClass('followed')

          } else {
            $(this).addClass('allowed');
            error(i18n[lang].character_Failed_Remove);
            $(this).addClass('active');
            staTus.num_common++
            $('.collection_num').html(staTus.num_common);
          }
        }).catch(res => {
          error(i18n[lang].character_Failed_Remove);
          $(this).addClass('active');
          staTus.num_common++
          $('.collection_num').html(staTus.num_common);
        });
      } else if ($(this).attr('class').indexOf('allowed') > -1 && $(this).attr('class').indexOf('active') == -1 && $(this).attr('class').indexOf('fit') == -1) {
        $('.character .collection span').animate({ opacity: 1, top: '-1.125rem' }).delay(3000).animate({ opacity: 0, top: '-1rem' }, 10);
        $(this).addClass('active');
        $(this).removeClass('allowed');
        $(this).addClass('fit');
        staTus.num_common++
        $('.collection_num').html(staTus.num_common);
        getAjax(_url.collectUpdate, {
          "roleid": link_before,
          "be_collected_id": _uid,
          "status": 1
        }).then(res => {
          $(this).removeClass('fit');
          if (res.code == 200) {
            $(this).addClass('allowed');
            success(i18n[lang].character_Successfully_Add)
            $(this).addClass('active').addClass('followed')
          } else {
            $(this).addClass('allowed');
            error(i18n[lang].character_Failed_Add)
            $(this).removeClass('active');
            staTus.num_common--
            $('.collection_num').html(staTus.num_common);
          }
        }).catch(res => {
          error(i18n[lang].character_Failed_Add);
          $(this).removeClass('active');
          staTus.num_common--
          $('.collection_num').html(staTus.num_common);
        })
      }
    } else {
      // 接口返回之前 不能点击
      _notlogin();
    }
  });
  //喜欢 取消喜欢
  $('.character .btn_like').on('click', function () {
    checkLoginStatus();
    if (window.isLoggedIn) {
      if ($('.character .btn_like').attr('class').indexOf('allowed') > -1 && $('.character .btn_like').attr('class').indexOf('active') > -1 && $('.character .btn_like').attr('class').indexOf('fit') == -1) {
        $('.character .btn_like').addClass('fit');
        $('.character .btn_like').removeClass('allowed');
        $('.character .btn_like').removeClass('active');
        staTus.num_like--
        $('.like_num').html(staTus.num_like);
        getAjax(_url.likesUpdate, {
          "roleid": link_before,
          "be_liked_id": _uid,
          "status": 0
        }).then(res => {
          $('.character .btn_like').removeClass('fit');
          if (res.code == 200) {
            $('.character .btn_like').addClass('allowed');
            success(i18n[lang].public_Successfully_Unlike);
            $('.character .btn_like').removeClass('active').removeClass('followed')
          } else {
            $('.character .btn_like').addClass('allowed');
            error(i18n[lang].public_Failed_Unlike);
            $('.character .btn_like').addClass('active');
            staTus.num_like++
            $('.like_num').html(staTus.num_like);
          }
        }).catch(res => {
          error(i18n[lang].public_Failed_Unlike);
          $('.character .btn_like').addClass('active');
          staTus.num_like++
          $('.like_num').html(staTus.num_like);
        });
      } else if ($('.character .btn_like').attr('class').indexOf('allowed') > -1 && $('.character .btn_like').attr('class').indexOf('active') == -1 && $('.character .btn_like').attr('class').indexOf('fit') == -1) {
        $('.character .character_like span').animate({ opacity: 1, top: '-1.125rem' }).delay(3000).animate({ opacity: 0, top: '-1rem' }, 10);
        $('.character .btn_like').addClass('active');
        $('.character .btn_like').removeClass('allowed');
        $('.character .btn_like').addClass('fit');
        staTus.num_like++
        $('.like_num').html(staTus.num_like);
        getAjax(_url.likesUpdate, {
          "roleid": link_before,
          "be_liked_id": _uid,
          "status": 1
        }).then(res => {
          $('.character .btn_like').removeClass('fit');
          if (res.code == 200) {
            $('.character .btn_like').addClass('allowed');
            success(i18n[lang].public_Successfully_Like)
            $('.character .btn_like').addClass('active').addClass('followed')
          } else {
            $('.character .btn_like').addClass('allowed');
            error(i18n[lang].public_Failed_Like)
            $('.character .btn_like').removeClass('active');
            staTus.num_like--
            $('.like_num').html(staTus.num_like);
          }
        }).catch(res => {
          error(i18n[lang].public_Failed_Like);
          $('.character .btn_like').removeClass('active');
          staTus.num_like--
          $('.like_num').html(staTus.num_like);
        })
      }
    } else {
      // 接口返回之前 不能点击
      _notlogin();
    }
  });
});
// 评分提示信息
$('.character .rating_zoon i').on('click', function (e) {
  e.stopPropagation();
  e.preventDefault();
  $(this).addClass('active');
  $('.rating_mask').addClass('active');
  $('.rating_mask h2').trigger('click');
  $(this).prop('checked', false);
  $(this).blur();
  $('.rating_mask .rating_btn').focus();
});
$('.rating_mask .rating_info .rating_btn,.rating_mask .rating_close').on('click', function (e) {
  $('.rating_mask').removeClass('active');
});
$('.rating_mask .rating_info').on('click', function (e) {
  e.stopPropagation();
  e.preventDefault();
});
$('#report_form').attr('role_id', link_before);
// 举报功能
$(document).on('click', '.rightNavigation .report', function (e) {
  e.stopPropagation();
  e.preventDefault();
  $('.rightNavigation .more').removeClass('active');
  $('.rightNavigation .function_lists').removeClass('active');
  report_arguments(link_before, $('.character_name').html(), $('.character_nsfw').html())
});
let textareaLine = 1;
// 定义一个函数来获取textarea的行数
const getTextareaLineCount = (textarea) => {
  const text = textarea.value;
  const linesFromContent = text ? text.split(/\r\n|\r|\n/).length : 1;

  // 创建一个隐藏的文本区域，用于测量行高
  const clone = document.createElement('textarea');
  clone.style.visibility = 'hidden';
  clone.style.position = 'absolute';
  clone.style.height = '3rem';
  clone.style.overflow = 'hidden';
  clone.style.whiteSpace = 'pre-wrap';
  clone.style.wordWrap = 'break-word';

  // 设置与原文本域相同的样式
  const styles = window.getComputedStyle(textarea);
  clone.style.width = styles.width;
  clone.style.fontFamily = styles.fontFamily;
  clone.style.fontSize = styles.fontSize;
  clone.style.lineHeight = styles.lineHeight;
  clone.style.padding = styles.padding;
  clone.style.border = styles.border;
  clone.style.boxSizing = styles.boxSizing;

  // 添加到文档中以便测量
  document.body.appendChild(clone);

  // 获取单行高度
  clone.value = 'A';
  const singleLineHeight = clone.scrollHeight;

  // 获取总内容的高度
  clone.value = text || 'A';
  const totalHeight = clone.scrollHeight;

  // 移除克隆的元素
  document.body.removeChild(clone);

  // 计算行数，考虑1px误差
  const tolerance = 1;
  let linesFromHeight = Math.max(1, totalHeight / singleLineHeight);

  // 检查是否存在误差并调整行数
  if (Math.abs(totalHeight % singleLineHeight) <= tolerance) {
    linesFromHeight = Math.floor(totalHeight / singleLineHeight);
  }

  return Math.max(linesFromContent, linesFromHeight);
};
const adjustTextareaHeightCharacter = event => {
  // 获取文本域中的文本内容
  const textarea = event.target;
  const text = textarea;
  if (text.length == 0) {
    textareaLine = 1;
    lineCount = 1;
    return;
  }
  // 计算文本内容中换行符的数量，即行数
  let count = getTextareaLineCount(textarea);
  count = count >= 5 ? 5 : count;
  lineCount = count
  // lineCount.value = (text.match(/\n/g) || []).length + 2;
  const newHeight = lineCount;
  setTimeout(() => {
    if (textareaLine !== newHeight) {
      textareaLine = newHeight
    }
    text.style.height = (textareaLine * 1.25 + 2) + 'rem'
  }, 0);
}

// 监听textarea的输入事件
const textarea = document.getElementById('comment-txt');
textarea.addEventListener('input', adjustTextareaHeightCharacter);
$(document).on('click','.collapse-icon', function (e) {
  $(this).parent().addClass('expanded');
})

function showError(elementId, message) {
  document.getElementById(elementId).textContent = message;
}
function clearErrors(elementId) {
  const element = document.getElementById(elementId);
  if (element) {
    element.textContent = '';
  } else {
    console.error(`元素 ID "${elementId}" 不存在于文档中`);
  }
}


//获取评论
getCommentList();
function getCommentList() {
  getAjax('/api/oneCommentList', {
    "robot_id": link_before,
    "pageNum": 1,
  }).then(res => {
    if (res.code == 200) {
      let data = res.data
      createComments(data)

    }
  });

}

// 插入评论
function createComments(commentsData) {
  // 获取页面上的评论容器元素
  const commentContainer = document.querySelector('.comment-content-box');

  // 遍历数据数组，为每个评论创建一个DOM元素
  const comments = commentsData.map(comment => {
    // 创建一个新的评论容器元素
    const newCommentItem = document.createElement('div');
    newCommentItem.classList.add('comment-content-item');

    // 创建一个新的图片元素
    const newLink = document.createElement('a');
    newLink.href = host_name + `${lang_path}/account/profile/` + (comment.userProfile && comment.userProfile.openid);
    const newImage = document.createElement('img');
    newImage.classList.add('images');
    newImage.src = comment.userProfile && comment.userProfile.avatar_url;
    newLink.appendChild(newImage);
    newCommentItem.setAttribute('comment-id', comment.id)
    newCommentItem.setAttribute('id', comment.id)
    newCommentItem.appendChild(newLink);

    // 创建一个新的评论内容右部元素
    const newCommentRight = document.createElement('div');
    newCommentRight.classList.add('comment-content-right');
    newCommentItem.appendChild(newCommentRight);

    // 创建一个新的评论中间信息元素
    const newCommentMiddleInfo = document.createElement('div');
    newCommentMiddleInfo.classList.add('comment-middle-info');
    newCommentRight.appendChild(newCommentMiddleInfo);

    // 创建一个新的昵称元素
    const newName = document.createElement('a');
    newName.classList.add('name');
    newName.href = host_name + `${lang_path}/account/profile/` + (comment.userProfile && comment.userProfile.openid);
    newName.textContent = comment.userProfile.nickname;
    newCommentMiddleInfo.appendChild(newName);

    // 创建一个新的评论内容元素
    const newContent = document.createElement('span');
    newContent.classList.add('content');
    newContent.textContent = comment.comment_details;
    newCommentMiddleInfo.appendChild(newContent);

    // 创建一个新的评论时间元素
    const newTime = document.createElement('span');
    newTime.classList.add('time');
    newTime.textContent = comment.createtime;
    newCommentMiddleInfo.appendChild(newTime);

    // 创建一个新的点赞盒子元素
    const newZanBox = document.createElement('div');
    if (comment.status == 1) {
      newZanBox.classList.add('zan-box');
      newZanBox.classList.add('active');
    } else {
      newZanBox.classList.add('zan-box');

    }
    newZanBox.setAttribute('zan-status', comment.status)
    newCommentRight.appendChild(newZanBox);

    // 创建一个新的点赞图标元素
    const newZanIcon = document.createElement('i');
    newZanIcon.classList.add('zan-icon');

    newZanBox.appendChild(newZanIcon);

    // 创建一个新的点赞数量元素
    const newZanNum = document.createElement('span');
    newZanNum.textContent = comment.like_num;
    newZanBox.appendChild(newZanNum);

    // 返回新创建的评论元素
    return newCommentItem;
  });

  commentContainer.innerHTML = '';
  // 将所有评论元素添加到页面上的评论容器元素中
  comments.forEach(comment => commentContainer.appendChild(comment));
  if(window.location.href.indexOf('?#') !== -1){
    $('.tab_section .tab_item').eq(1).trigger('click');
    if($(window).width()<769){
        setTimeout(function() {
          $('.ivu-row-center').scrollTop($(window.location.href.split('?')[1]).offset().top-$(window.location.href.split('?')[1]).height());
        },1000);
    }else{
      $('.ivu-row').scrollTop($(window.location.href.split('?')[1]).offset().top-$(window.location.href.split('?')[1]).height());
    }
    $(window.location.href.split('?')[1]).addClass('shine');
  };
  $('.comment-content-item').on('click',function(e) {
    $(this).removeClass('shine')
  })
}

//发布评论
$('.comment_submit').on('click', function () {
  checkLoginStatus()
  if (window.isLoggedIn) {
    if (!isValid) {
      return false
    }
    const commentTxtEle = document.getElementById('comment-txt');
    let commentDetails = commentTxtEle.value.trim();
    if (commentDetails.length > 200 || commentDetails.length == 0) {
      showError('commentTxtError', i18n[lang].public_length_characters_200);
      return false
    }
    isValid = false;
    getAjax('/api/addComment', {
      "robot_id": link_before,
      "commentDetails": commentDetails,
    }).then(res => {
      if (res.code == 200) {
        success(i18n[lang].public_Comment+i18n[lang].chat_story_Successfully)
        manage('Comment_Click', '');
        getCommentList();
        commentTxtEle.value = '';
        commentTxtEle.style.height = '3rem';
      } else {
        error(i18n[lang].public_Comment+i18n[lang].chat_story_Failed)
      }
      isValid = true

    }).catch(() => {
      error(i18n[lang].public_Comment+i18n[lang].chat_story_Failed)
      isValid = true
    });
  } else {
    _notlogin();
  }
});

// 监听点击事件
document.querySelector('.comment-content-box').addEventListener('click', function (event) {

  // 检查点击的目标是否是zan-box
  if (event.target.className === 'zan-icon') {
    // 获取评论ID

    const commentId = event.target.parentNode.parentNode.parentNode.getAttribute('comment-id');
    const status = event.target.parentNode.getAttribute('zan-status');
    // 调用点赞函数
    likeComment(commentId, status);
  }
});

// 点赞函数
function likeComment(commentId, status) {
  getAjax('/api/commentUpdate', {
    "comment_id": commentId,
    status: status == 1 ? '0' : '1',
  }).then(res => {
    if (res.code === 200) {
      // 更新点赞数量
      const zanBox = document.querySelector(`.comment-content-item[comment-id="${commentId}"] .zan-box`);
      zanBox.setAttribute("zan-status", status == 1 ? '0' : '1')
      if (status == 1) {
        // 取消点赞
        zanBox.querySelector('span').textContent = Number(zanBox.querySelector('span').textContent) - 1
        zanBox.classList.remove('active')
        // success(i18n[lang].public_Successfully_Unlike)

      } else {
        // 点赞
        zanBox.querySelector('span').textContent = Number(zanBox.querySelector('span').textContent) + 1
        zanBox.classList.add('active')
        // success(i18n[lang].public_Successfully_Like)

      }
    }


  }).catch(error => {
    // const zanBox = document.querySelector(`.comment-content-item[comment-id="${commentId}"] .zan-box`);
    // zanBox.querySelector('span').textContent = data.like_num;
  });
}
{/* <p id='person_greetings'></p> */ }
$(document).ready(function () {
  // 获取包含文本的元素
  try{var greetingsDom = document.getElementById('person_greetings');
  var personalizedDom = document.getElementById('person_personalized');
  var infoDom = document.getElementById('personal_info');
  var scenarioDom = document.getElementById('person_scenario');


  // 检查文本内容是否超过三行
  checkTextOverflow(greetingsDom);
  checkTextOverflow(personalizedDom);
  checkTextOverflow(scenarioDom);checkTextOverflow(infoDom);}catch(e){}


  function checkTextOverflow(textBox) {

    // 获取单行文本的高度
    var lineHeight = parseInt(window.getComputedStyle(textBox).lineHeight);
    // 获取盒子的实际高度
    var boxHeight = textBox.offsetHeight;
    if (boxHeight > 3 * lineHeight) {
      textBox.classList.add('collapsed');
    } else {
      textBox.classList.remove('collapsed').add('expanded')
    }
  }
})


$('.errorPop .close').on('click', function (e) {
  $(this).parent().css('display', 'none').attr('style', function(i, style) {
    return style + ' display: none !important;';
});
})
if($(window).width()<769){
    $('.ivu-row-center').removeClass('scrollLogic').css({'width':'100%'});
    $('html').addClass('scrollLogic').addClass('scroll-active').css({'overflowY':'scroll','background':'#f5f6f9'});
    $('.layout-header').css({'position':'fixed','top':0,'zIndex':99,'width':'100%','box-sizing':'border-box'});
    $('.main_section').css({'overflowY':'visible'});
    defaultDisplayOfScrollbar();
};
$('.tab_section .tab_item').on('click',function(){
  $(this).addClass('active').siblings().removeClass('active');
  var index = $(this).index();
  story_index = index;
  $('.tab_part').eq(index).removeClass('hide').siblings('.tab_part').addClass('hide');
});
function addChatStorySectionLoading() {
  let rowNum = 4;
  let screenWidth = $(window).width();
  if (screenWidth >= 1600) {
      rowNum = 4;
  } else if (screenWidth >= 1100) {
      rowNum = 3;
  } else if (screenWidth >= 560) {
      rowNum = 2;
  } else {
      rowNum = 1;
  }
  let numberOfSkeletons = rowNum - $('.story_section .itemDiv').length % rowNum;
  for (let i = 0; i < numberOfSkeletons; i++) {
      $('.main_right .story_section').append(`  <div class="ivu-col ivu-col-span-xs-12 ivu-col-span-sm-12 ivu-col-span-md-8 ivu-col-span-lg-6 ivu-col-span-xl-4 ivu-col-span-xxl-4 tempItemDiv">
                  <a href="${lang_path}/character/446417/story/26" id="robot44641726" class="item homeItemInPHP" data-roleid="441920">
                    <p class="story_name" style="width: 129px;height: 20px;background: #F5F6F9;border-radius: 30px;margin:0;align-self: flex-start;"></p>
                    <p class="story_author" style="width: 177px;height: 20px;background: #F5F6F9;border-radius: 30px;margin:10px  0;align-self: flex-start;"> <span class="author_name" attr-id="8778787134"></span></p>
                    <div class="story_info" style="height: 12rem;" >
                        <p style="width: 90%;height: 24px;border-radius: 30px;background: rgba(167,79,255,0.1)!important;margin-bottom:8px;"></p>
                        <p style="width: 70%;height: 24px;border-radius: 30px;background: rgba(167,79,255,0.1)!important;margin-bottom:8px;"></p>
                        <p style="width: 90%;height: 24px;border-radius: 30px;background: rgba(167,79,255,0.1)!important;margin-bottom:8px;"></p>
                        <p style="width: 70%;height: 24px;border-radius: 30px;background: rgba(167,79,255,0.1)!important;"></p>
                    </div>
                    <div class="status_info flex_box">
                      <div class="status_item">
                        <p class="status_title" style="width: 44px;height: 24px;border-radius: 30px;background: #F5F6F9;"> </p>
                        <p class="status_info" style="width: 70px;height: 20px;border-radius: 30px;background: #F5F6F9;" > </p>
                      </div>
                      <div class="status_item">
                      <p class="status_title" style="width: 44px;height: 24px;border-radius: 30px;background: #F5F6F9;"> </p>
                      <p class="status_info" style="width: 70px;height: 20px;border-radius: 30px;background: #F5F6F9;" > </p>
                      </div>
                      <div class="status_item">
                      <p class="status_title" style="width: 44px;height: 24px;border-radius: 30px;background: #F5F6F9;"> </p>
                      <p class="status_info" style="width: 70px;height: 20px;border-radius: 30px;background: #F5F6F9;" > </p>
                      </div>
                    </div>
                  </a>
                </div>`)
  }
  $('.story_section .itemDiv').on('load', function () {
      $('.story_section .itemDiv').scheletrone({
          url: '', // 不请求数据
          ajaxData: {}, // 空数据
          debug: {
              log: false,
              latency: 0 // 无延迟
          },
          removeIframe: false, // 不移除 iframe
          maskText: true, // 掩盖文本内容
          skelParentText: false, // 不掩盖父元素文本
          backgroundImage: true, // 处理背景图片
          replaceImageWith: 'bg-image', // 图片替换为背景
          selector: '.item', // 选择 .item 作为骨架图展示目标
          incache: false, // 不缓存数据
          ignoreSelector: '.bottom .bottomItem span', // 指定不应用骨架图效果的元素
          onComplete: function () {

          }
      });
  })
};
addChatStorySectionLoading();
function addCharacterSectionLoading() {
      $('.main_right .left_info').append(`<div class="creator_section tempItemDiv">
      <div class="item">
      <div class="creator_top flex_box">
        <a href="" class="character_link"><img id="creator_img" src="/images/index/defaultAvatar.svg" alt="Character Avatar" width="66" height="66"/></a>
        <div class="middle_part">
          <p class="creator_name" style="width: 129px;height: 20px;background: rgba(167,79,255,0.1);border-radius: 30px;align-self: flex-start;"></p>
          <div class="interactive_zoon flex_box">
            <p><i class="icon_chat"></i>
            <span class="num_chat" style="width: 29px;height: 20px;background: rgba(167,79,255,0.1);border-radius: 30px;align-self: flex-start;"></span></p>
            <p><i class="icon_follow"></i>
            <span class="num_follow" style="width: 29px;height: 20px;background: rgba(167,79,255,0.1);border-radius: 30px;align-self: flex-start;"></span></p>
          </div>
        </div>
        <a href="" class="jump"></a>
      </div>
      <p class="info" id="creator_Introduction" style="height: 24px;background: rgba(167,79,255,0.1);border-radius: 30px;align-self: flex-start;"></p>
      <span class="follow_btn" style="background: rgba(167,79,255,0.1);"></span>
      <ul class="character_list">
        <li>
          <a href="" class="character_li">
            <div class="character_up flex_box" style="justify-content:flex-start">
              <img id="character_img" src="/images/index/defaultAvatar.svg" alt="Character Avatar" width="128" height="128" />
              <div class="middle_part">
                <p class="character_name" style="width: 129px;height: 20px;background: rgba(167,79,255,0.1);border-radius: 30px;align-self: flex-start;"></p>
                <div class="interactive_zoon flex_box">
                  <p><i class="icon_chat"></i>
                  <span class="num_chat" style="width: 29px;height: 20px;background: rgba(167,79,255,0.1);border-radius: 30px;align-self: flex-start;"></span></p>
                  <p><i class="icon_like"></i>
                  <span class="num_like" style="width: 29px;height: 20px;background: rgba(167,79,255,0.1);border-radius: 30px;align-self: flex-start;"></span></p>
                </div>
                <p class="character_info" style="margin: 16px 0 0;width: 129px;height: 40px;background: rgba(167,79,255,0.1);border-radius: 30px;align-self: flex-start;"></p>
              </div>
            </div>
            <span class="to_chat" style="background: rgba(167,79,255,0.1);"></span>
          </a>
        </li>
      </ul>
      <a href="" class="view_all"></a>
      </div></div>`);
  $('.left_info .itemDiv').on('load', function () {
      $('.left_info .itemDiv').scheletrone({
          url: '', // 不请求数据
          ajaxData: {}, // 空数据
          debug: {
              log: false,
              latency: 0 // 无延迟
          },
          removeIframe: false, // 不移除 iframe
          maskText: true, // 掩盖文本内容
          skelParentText: false, // 不掩盖父元素文本
          backgroundImage: true, // 处理背景图片
          replaceImageWith: 'bg-image', // 图片替换为背景
          selector: '.item', // 选择 .item 作为骨架图展示目标
          incache: false, // 不缓存数据
          ignoreSelector: '.bottom .bottomItem span', // 指定不应用骨架图效果的元素
          onComplete: function () {
            console.log('onComplete');
          }
      });
  })
};
addCharacterSectionLoading();
$('.chat_person').on('click',function(e){
  e.preventDefault();
  window.location.href = `https://heyreal.ai`+$(this).attr('href').replace(lang_path,'');
});
